import React, { useCallback, useState, useEffect } from "react";
import style from "./styles.module.scss";
import {
  Col,
  Row,
  Button,
  Input,
  InputGroup,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
  UncontrolledDropdown,
  Spinner,
} from "reactstrap";
import { debounce } from "../../../utils/Helper";
import { AssetStatus } from "../types";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";

const Toolbar = ({
  onChange: rootOnChange,
  subClasses,
  filter: rootFilter,
  counters,
  Link,
  role,
  searchAsset,
  fromPage,
}) => {
  const [filters, setFilters] = useState(rootFilter);

  const debounceCallback = useCallback(
    debounce((nextValues) => rootOnChange(nextValues), 500),
    []
  );

  const onChange = (fields) => {
    const nextValues = {
      ...filters,
      ...fields,
    };
    debounceCallback(nextValues);
    setFilters(nextValues);
  };

  return (
    <div className={style.toolbar}>
      <Row>
        <Col lg={2}>
          <Counter {...counters} fromPage={fromPage} />
        </Col>
        <Col lg={4}>
          <InputGroup>
            <div className="input-group-prepend">
              <span className="input-group-text">
                <i className="fa fa-search"></i>
              </span>
            </div>

            <Input
              type="text"
              placeholder="Search something"
              value={filters.text}
              onChange={(e) => onChange({ text: e.target.value })}
            />
          </InputGroup>
        </Col>

        <Col lg={5}>
          <div className="d-flex justify-content-between">
            {/* {subClasses ? (
              <DropDownFilterSubClass value={filters.subAssetClass} items={subClasses} onChange={onChange} />
            ) : (
              <Spinner size="sm" className="mt-2 ml-3 mr-3" />
            )*/}

            <DropDownFilterStatus value={filters.status} onChange={onChange} />

            <LaddaButton
              className="btn btn-ladda btn-primary ml-2 mr-2"
              loading={false}
              disabled={false}
              onClick={() => searchAsset()}
              data-style={EXPAND_RIGHT}
            >
              Search
            </LaddaButton>

            {/* {role == "advisor" ? (
              <div />
            ) : (
              <Button color="primary" tag={Link} to="/asset">
                <i className="fa fa-plus mr-1"></i>
                {fromPage != "funds" ? "New Asset" : "New Fund"}
              </Button>
            )} */}
          </div>
        </Col>
      </Row>
    </div>
  );
};

const Counter = ({ total, fromPage }) => (
  <div className="d-none d-lg-block">
    <h6 className={"h6 page-title " + style.totals}>
      {" "}
      {fromPage != "funds" ? "Assets:" : "Funds:"} {total}
    </h6>
  </div>
);
/*
const DropDownFilterSubClass = ({ value, items, onChange }) => (
  <UncontrolledDropdown style={{ minWidth: "160px" }}>
    <DropdownToggle caret color="secondary" className={style.dropdown}>
      {!value ? "All Subclasses" : items.find((e) => e.SubAssetClassId == value).SubAssetClassName}
    </DropdownToggle>
    <DropdownMenu className={style.menu}>
      <DropdownItem key={`subclasses-all`} onClick={() => onChange({ subAssetClass: 0 })}>
        {"All Subclasses"}
      </DropdownItem>
      {items.map((item) => (
        <DropdownItem
          key={`subclasses-${item.SubAssetClassId}`}
          onClick={() => onChange({ subAssetClass: item.SubAssetClassId })}
        >
          {item.SubAssetClassName}
        </DropdownItem>
      ))}
    </DropdownMenu>
  </UncontrolledDropdown>
);*/

const DropDownFilterStatus = ({ value, onChange }) => (
  <UncontrolledDropdown style={{ minWidth: "140px" }}>
    <DropdownToggle caret color="secondary" className={style.dropdown}>
      {value == "" ? "All Statusses" : value}
    </DropdownToggle>
    <DropdownMenu>
      <DropdownItem key={`status-all`} onClick={() => onChange({ status: "" })}>
        {"All Statusses"}
      </DropdownItem>
      {Object.values(AssetStatus).map((status) => (
        <DropdownItem key={`status-${status}`} onClick={() => onChange({ status: status })}>
          {status}
        </DropdownItem>
      ))}
    </DropdownMenu>
  </UncontrolledDropdown>
);

export default Toolbar;
